/* Offerta quantità selezionabile — 2 ottobre 2026.
   Il riquadro scelto imposta la quantità del modulo d'acquisto; se il cliente usa
   il selettore di quantità, il riquadro lo segue. Ascolto delegato sul documento:
   il blocco viene sostituito a ogni cambio di formato e uno script dentro un blocco
   sostituito non riparte. */
(function () {
  if (window.__astraOffertaQuantita) return;
  window.__astraOffertaQuantita = true;

  function radice(el) {
    return (el && el.closest && el.closest('product-form')) || document;
  }

  function campoQuantita(r) {
    return r.querySelector('input[name="quantity"]');
  }

  /* Quantità libera (8 ottobre 2026): sopra le tre confezioni nessun riquadro resta
     scelto, la quantità sta nel campo «Scrivi quante» e il conto si fa qui. Dalla terza
     confezione in su lo sconto automatico è il 20%, come nei riquadri. */
  function soldi(centesimi, esempio) {
    var n = (centesimi / 100).toFixed(2).split('.');
    var cifra = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1];
    return esempio && /[\d.,]+/.test(esempio) ? esempio.replace(/[\d.,]+/, cifra) : '€' + cifra;
  }

  function allinea(r) {
    var campo = campoQuantita(r);
    var q = campo ? parseInt(campo.value, 10) || 1 : 1;
    var scelta = q <= 3 ? q : 0;
    var totale = '';
    r.querySelectorAll('[data-astra-oq] input[type="radio"]').forEach(function (i) {
      i.checked = parseInt(i.value, 10) === scelta;
      if (i.checked) totale = i.getAttribute('data-totale') || '';
    });
    var riga = r.querySelector('[data-astra-oq-libero-riga]');
    if (riga) {
      var libero = riga.querySelector('[data-astra-oq-libero]');
      var conto = riga.querySelector('[data-astra-oq-libero-conto]');
      var prezzo = parseInt(riga.getAttribute('data-prezzo'), 10) || 0;
      if (q > 3 && prezzo) {
        var pieno = prezzo * q;
        totale = soldi(pieno - Math.round(pieno * 20 / 100), riga.getAttribute('data-esempio'));
        if (libero && libero.value !== String(q)) libero.value = q;
        if (conto) conto.textContent = q + ' confezioni −20% · ' + totale;
        riga.classList.add('astra-oq__libero--scelto');
      } else {
        if (libero && parseInt(libero.value, 10) !== q) libero.value = '';
        if (conto) conto.textContent = '';
        riga.classList.remove('astra-oq__libero--scelto');
      }
    }
    scriviTotale(r, totale);
  }

  function daCampoLibero(t) {
    var n = parseInt(t.value, 10);
    if (!n || n < 1) return;
    if (n > 999) { n = 999; t.value = n; }
    var campo = campoQuantita(radice(t));
    if (campo && campo.value !== String(n)) {
      campo.value = n;
      campo.dispatchEvent(new Event('change', { bubbles: true }));
    }
    allinea(radice(t));
  }

  /* Il pulsante d'acquisto dice quanto si paga con la scelta fatta. Il testo del
     pulsante è del tema (lo riscrive al cambio di formato e dopo l'aggiunta al
     carrello): qui si aggiunge solo un pezzo in coda, e si rimette quando sparisce. */
  function scriviTotale(r, totale) {
    if (!r.querySelector('[data-astra-oq]')) return;
    var pulsante = r.querySelector('button[name="add"]');
    if (!pulsante) return;
    var coda = pulsante.querySelector('.astra-oq__nel-pulsante');
    if (!totale || pulsante.disabled) {
      if (coda) coda.remove();
      return;
    }
    if (!coda) {
      coda = document.createElement('span');
      coda.className = 'astra-oq__nel-pulsante';
      pulsante.appendChild(coda);
    }
    coda.textContent = ' · ' + totale;
  }

  function allineaTutti() {
    document.querySelectorAll('product-form').forEach(allinea);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-astra-oq] input[type="radio"]')) {
      var campo = campoQuantita(radice(t));
      if (campo && campo.value !== t.value) {
        campo.value = t.value;
        campo.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (t.matches('[data-astra-oq-libero]')) {
      daCampoLibero(t);
    } else if (t.matches('input[name="quantity"]')) {
      allinea(radice(t));
    }
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-astra-oq-libero]')) daCampoLibero(t);
  });

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-quantity]')) {
      var r = radice(e.target);
      setTimeout(function () { allinea(r); }, 60);
    }
  });

  document.addEventListener('on:variant:change', function () {
    setTimeout(allineaTutti, 500);
    setTimeout(allineaTutti, 1500);
  });

  document.addEventListener('on:cart:add', function () {
    setTimeout(allineaTutti, 1200);
    setTimeout(allineaTutti, 3500);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', allineaTutti);
  } else {
    allineaTutti();
  }
})();
